
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-loading',
    imports: [
    ButtonModule
],
    templateUrl: './loading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  private _sub?: Subscription;
  logo: string = 'assets/img/surveypro.png'

  /** หากว่าเกิดว่าโหลดนานเกินขีดเวลาที่กำหนด */
  @Output('onTimeout') onTimeoutEvent = new EventEmitter<void>();

  /** ปรับขนาดของ Loading */
  @Input('scale') scale: '1' | '2' | '3' = '2';

  /** เวลา timeout หากว่าโหลดนานเกินไป */
  @Input('timeout') timeout: number = 30;

  /** ตรวจสอบว่าโหลดนานเกินไปหรือไม่ */
  isTimeout: boolean = false;

  ngAfterViewInit(): void {
    if (!this.onTimeoutEvent.observed) return;
    this._sub = timer(this.timeout * 1000).subscribe(() => {
      this.isTimeout = true;
    });
  }

  ngOnDestroy(): void {
    this.isTimeout = false;
    this._sub?.unsubscribe();
  }

  /** กดปุ่มปิดเมื่อ Timeout */
  onTimeout() { this.onTimeoutEvent.emit(); }
}
